import React from "react";
import { Link } from "react-router-dom";
import bgheader5png from "../../../assets/images/bg-header-5.png";

function Settings(props) {
  return (
    <>
      <header className="dx-header dx-box-5">
        <div className="container">
          <div className="bg-image bg-image-parallax">
            <img src={bgheader5png} className="jarallax-img" alt="" />
            <div style={{ backgroundColor: "rgba(27, 27, 27, 0.8)" }}></div>
          </div>
          <div className="container mnb-8">
            <h1 className="h4 mb-10 text-white text-center">Settings</h1>

            <ul className="dx-breadcrumbs text-center">
              <li>
                <Link to="/index">Home</Link>
              </li>
              <li>Settings</li>
            </ul>
          </div>
        </div>
      </header>
      <div className="dx-box-5 pb-100 bg-grey-6">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10 col-xl-7">
              <div className="dx-box-decorated">
                <div className="dx-box-content">
                  <h2 className="h6 mnt-5 mnb-5">Profile Information</h2>
                </div>
                <div className="dx-separator"></div>
                <form action="#" className="dx-form">
                  <div className="dx-box-content">
                    <div className="dx-form-group">
                      <label for="first-name" className="mnt-7">
                        First Name
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-style-2"
                        id="first-name"
                        placeholder="Enter First Name"
                      />
                    </div>
                    <div className="dx-form-group">
                      <label for="last-name" className="mnt-7">
                        Last Name
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-style-2"
                        id="last-name"
                        placeholder="Enter Last Name"
                      />
                    </div>
                    <div className="dx-form-group">
                      <label for="display-name" className="mnt-7">
                        Display Name
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-style-2"
                        id="display-name"
                        placeholder="John Leonard"
                      />
                    </div>
                    <div className="dx-form-group">
                      <label for="email-address" className="mnt-7">
                        Primary Email Address
                      </label>
                      <input
                        type="email"
                        aria-describedby="emailHelp"
                        className="form-control form-control-style-2"
                        id="email-address"
                        placeholder="Enter Email Address"
                      />
                    </div>
                    <div className="dx-form-group">
                      <label for="line-one" className="mnt-7">
                        Line 1
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-style-2"
                        id="line-one"
                        placeholder=""
                      />
                    </div>
                    <div className="dx-form-group">
                      <label for="line-two" className="mnt-7">
                        Line 2
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-style-2"
                        id="line-two"
                        placeholder=""
                      />
                    </div>
                    <div className="dx-form-group">
                      <label for="city" className="mnt-7">
                        City
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-style-2"
                        id="city"
                        placeholder="Enter City Name"
                      />
                    </div>
                    <div className="dx-form-group">
                      <label for="zip" className="mnt-7">
                        ZIP / Postal Code
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-style-2"
                        id="zip"
                        placeholder="Enter ZIP / Postal Code"
                      />
                    </div>
                    <div className="dx-form-group">
                      <button className="dx-btn dx-btn-xl dx-btn-block">
                        Save Changes
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Settings;
